module.exports = __webpack_public_path__ + "img/p3.09649933.png";